var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFav(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    stroke: "white",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5091 6.74837L12 7.26529L11.4908 6.74829C10.5625 5.80523 9.29461 5.27417 7.97132 5.27417C6.64804 5.27417 5.38012 5.80523 4.45182 6.74829V6.74829C2.51606 8.73754 2.51606 11.9064 4.45182 13.8957L9.84447 19.3713C10.413 19.9489 11.1896 20.2741 12 20.2741C12.8105 20.2741 13.587 19.9489 14.1556 19.3713L19.5482 13.8958C21.4839 11.9065 21.4839 8.73764 19.5482 6.74838V6.74838C18.6199 5.80529 17.3519 5.2742 16.0286 5.2742C14.7053 5.2742 13.4374 5.80528 12.5091 6.74837Z",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFav);
export default __webpack_public_path__ + "static/media/fav.94c39290d3e1a01af5bd94b798dcf41f.svg";
export { ForwardRef as ReactComponent };